module.exports = __webpack_public_path__ + "static/cordon-f93e6880fe0843eeb9fe7b39aab5b9d1.jpg";